module.exports = __webpack_public_path__ + "5cfa1c0affe50b9eb12fa3cee851729f.png";